import { useState } from "react";

/**
 * How much of a wide item screen the photo gets: half of it, or a narrow
 * column that leaves the details room to breathe. Only a desktop has the
 * choice; a phone stacks the photo above the details whatever this says.
 *
 * Remembered per device, like the items view. Unset, the photo is large: it
 * is what most people opened the item to look at.
 */

export type PhotoSize = "large" | "small";

const SIZE_KEY = "utucat.itemPhotoSize";

function readSize(): PhotoSize {
  try {
    if (window.localStorage.getItem(SIZE_KEY) === "small") return "small";
  } catch {
    // Storage can be blocked; the default is fine.
  }
  return "large";
}

export function usePhotoSize(): [PhotoSize, (next: PhotoSize) => void] {
  const [size, setSize] = useState<PhotoSize>(readSize);
  const choose = (next: PhotoSize) => {
    setSize(next);
    try {
      window.localStorage.setItem(SIZE_KEY, next);
    } catch {
      // Not remembered, still applied.
    }
  };
  return [size, choose];
}
